<template>
    <!-- 左侧悬浮框 -->
    <div class="left_box">
        <div class="box-item" v-for="(item, index) in menuList" :key="index"
            :class="hoverIndex === index ? 'item-box1' : 'item-box2'" @mouseenter="onMouseenter(index)"
            @mouseleave="onMouseleave(index)" @click="onClick(index)">
            <img :src="item.icon" alt="">
            <transition name="fade">
                <div class="item-txt" v-if="hoverIndex === index">{{ item.text }}</div>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LeftSuspension",
        data() {
            return {
                hoverIndex: -1, // 当前悬停的索引
                menuList: [
                    { icon: require("../../static/images/icon/icon15.png"), text: this.$t('商品') },
                    { icon: require("../../static/images/icon/icon16.png"), text: this.$t('订单') },
                    { icon: require("../../static/images/icon/icon17.png"), text: this.$t('购物车') }
                ],
                timeoutId: null // 用于存储定时器的ID
            };
        },
        methods: {
            /**点击事件 */
            onClick(i) {
                if (i == 0) {
                    this.$router.push({ name: "Search", params: { keyword: '' } });
                } else if (i == 1) {
                    this.$router.push({ name: 'MyOrder2', params: { type: 0 } });
                } else if (i == 2) {
                    this.$router.push({ name: 'ShoppingCart', params: { type: 1 } });
                }
            },
            /**鼠标移入事件 */
            onMouseenter(index) {
                // 清除上一个未触发的定时器
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                }
                this.hoverIndex = index;
            },
            /**鼠标移出事件 */
            onMouseleave(index) {
                // 延迟 100ms 才触发 hoverIndex 重置，避免边缘触发
                this.timeoutId = setTimeout(() => {
                    if (this.hoverIndex === index) {
                        this.hoverIndex = -1;
                    }
                }, 100);
            }
        }
    };
</script>

<style scoped lang="scss">
    .left_box {
        position: fixed;
        left: 18px;
        top: 40%;
        width: 120px;
        display: flex;
        flex-direction: column;
        align-items: end;
        z-index: 888;
    }

    .box-item {
        /* // background: linear-gradient(180deg, #57DD97 0%, #16C76B 100%); */
        background: #000000;
        opacity: 0.7;
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        /* 添加过渡动画 */
        transition: all 0.3s ease-in-out;
        box-sizing: border-box;

        img {
            width: 26px;
            height: 26px;
            transition: transform 0.3s ease-in-out;
        }
    }

    .box-item:nth-child(3) {
        margin-bottom: 0;
    }

    /* // **默认样式（未悬停）** */
    .item-box2 {
        width: 64px;
        height: 64px;
        border-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* // **悬停时的样式** */
    .item-box1 {
        width: 100%;
        height: 64px;
        box-sizing: border-box;
        border-radius: 8px;
        padding: 19px 0;
    }

    /* // **文字动画** */
    .item-txt {
        margin-left: 12px;
        font-size: 16px;
        color: #FFFFFF;
        transition: opacity 0.3s ease-in-out;
    }

    /* // **淡入淡出动画** */
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        transform: translateX(-10px);
    }
</style>


// WEBPACK FOOTER //
// src/components/leftSuspension.vue